import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function BulkCategory({ ids, onDone }) {
  const [items, setItems] = useState([]);
  const [cid, setCid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/product-categories", { params: { include_inactive: false } }).then(({ data }) => setItems(data.items)).catch(() => {}); }, []);
  const apply = async () => {
    setBusy(true);
    try { const { data } = await api.post("/products/bulk-category", { product_ids: ids, category_id: cid || null }); toast.success(`${data.updated} ürün → ${data.category || "Kategorisiz"}`); onDone(); }
    catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-2 panel px-3 py-2 mt-2" data-testid="bulk-category-bar">
      <span className="text-[13px] font-medium">{ids.length} ürün seçili</span>
      <select value={cid} onChange={(e) => setCid(e.target.value)} className="h-9 px-2 rounded-md border border-slate-300 text-sm" data-testid="bulk-category-select">
        <option value="">Kategorisiz</option>{items.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <Button size="sm" disabled={busy} onClick={apply} className="bg-blue-600 hover:bg-blue-700" data-testid="bulk-category-apply">Kategori Ata</Button>
    </div>
  );
}
